import { commonClientResx } from "~/resxDist/commonClientResx";
import { commonResx } from "~/resxDist/commonResx";
import { ItemKey, LabeledItem, ListItem, NamedItem } from "./types";

// id is optional for groups
export const getItemId = <TValue, TItem extends { id?: TValue }>(x: TItem) => x.id;
export const getItemName = <TItem extends { name: string }>(x: TItem) => x.name;
export const getItemLabel = <TItem extends { label: string }>(v: TItem) => v.label;
export const getItemValue = <TValue, TItem extends { value: TValue }>(x: TItem) => x.value;

const noneId: ItemKey = null;
export const noneOption: ListItem<any> & NamedItem<any> & LabeledItem<any> = {
    id: noneId,
    value: noneId,
    label: commonClientResx.None_Text,
    name: commonClientResx.None_Text,
};

export const booleanOptions: ListItem[] = [
    { id: 1, label: commonResx.yes },
    { id: 0, label: commonResx.no },
];
